import { render, staticRenderFns } from "./AnttComp.vue?vue&type=template&id=19f11bc1&scoped=true"
import script from "./AnttComp.vue?vue&type=script&lang=js"
export * from "./AnttComp.vue?vue&type=script&lang=js"
import style0 from "./AnttComp.vue?vue&type=style&index=0&id=19f11bc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f11bc1",
  null
  
)

export default component.exports